(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { useQuery as zr, useLazyQuery as qr, useMutation as Qr, isApolloError as Zr, gql as Me } from "@apollo/client";
import { __extends as Xr } from "tslib";
import lr, { useState as N, useEffect as M, createContext as ur, useContext as dr } from "react";
import { FormField as le, FieldWrapper as J, Badge as ke, Icon as Fe, FlexBox as k, Text as ee, List as er, Banner as et, Button as re, Modal as rt, ModalHead as tt, ModalBody as nt, ModalFoot as ot, Tooltip as fr, Spinner as pr, FieldSwitch as at, InputSelectionList as it, SelectionList as st } from "@dixa/lib-shared-habla";
import { Link as ct } from "react-router-dom";
import { colors as Y } from "@dixa/lib-shared-tokens";
import hr from "moment";
import { useInterval as lt } from "react-use";
import { HookFormText as ut } from "lib-shared-hook-form";
import { useController as dt } from "react-hook-form";
var je = "Invariant Violation", rr = Object.setPrototypeOf, ft = rr === void 0 ? function(r, t) {
  return r.__proto__ = t, r;
} : rr, pt = (
  /** @class */
  (function(r) {
    Xr(t, r);
    function t(a) {
      a === void 0 && (a = je);
      var i = r.call(this, typeof a == "number" ? je + ": " + a + " (see https://github.com/apollographql/invariant-packages)" : a) || this;
      return i.framesToPop = 1, i.name = je, ft(i, t.prototype), i;
    }
    return t;
  })(Error)
);
function K(r, t) {
  if (!r)
    throw new pt(t);
}
var gr = ["debug", "log", "warn", "error", "silent"], ht = gr.indexOf("log");
function Ee(r) {
  return function() {
    if (gr.indexOf(r) >= ht) {
      var t = console[r] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(r) {
  r.debug = Ee("debug"), r.log = Ee("log"), r.warn = Ee("warn"), r.error = Ee("error");
})(K || (K = {}));
var vr = "3.14.0";
function X(r) {
  try {
    return r();
  } catch {
  }
}
const tr = X(function() {
  return globalThis;
}) || X(function() {
  return window;
}) || X(function() {
  return self;
}) || X(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
X(function() {
  return X.constructor("return this")();
});
var nr = /* @__PURE__ */ new Map();
function gt(r) {
  var t = nr.get(r) || 1;
  return nr.set(r, t + 1), "".concat(r, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function vt(r, t) {
  var a = gt("stringifyForDisplay");
  return JSON.stringify(r, function(i, c) {
    return c === void 0 ? a : c;
  }, t).split(JSON.stringify(a)).join("<undefined>");
}
function be(r) {
  return function(t) {
    for (var a = [], i = 1; i < arguments.length; i++)
      a[i - 1] = arguments[i];
    if (typeof t == "number") {
      var c = t;
      t = yr(c), t || (t = Er(c, a), a = []);
    }
    r.apply(void 0, [t].concat(a));
  };
}
Object.assign(function(t, a) {
  for (var i = [], c = 2; c < arguments.length; c++)
    i[c - 2] = arguments[c];
  t || K(t, yr(a, i) || Er(a, i));
}, {
  debug: be(K.debug),
  log: be(K.log),
  warn: be(K.warn),
  error: be(K.error)
});
var or = Symbol.for("ApolloErrorMessageHandler_" + vr);
function mr(r) {
  if (typeof r == "string")
    return r;
  try {
    return vt(r, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function yr(r, t) {
  if (t === void 0 && (t = []), !!r)
    return tr[or] && tr[or](r, t.map(mr));
}
function Er(r, t) {
  if (t === void 0 && (t = []), !!r)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: vr,
      message: r,
      args: t.map(mr)
    })));
}
function xe(r) {
  return r.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
const on = (r, t) => function(a, i) {
  return zr(a, {
    ...i,
    context: {
      operationName: xe(a),
      ...i?.context,
      widgetId: r,
      widgetType: t
    }
  });
}, an = (r, t) => function(a, i) {
  return qr(a, {
    ...i,
    context: {
      operationName: xe(a),
      ...i?.context,
      widgetId: r,
      widgetType: t
    }
  });
}, sn = (r, t, a) => function(i, c) {
  return a.query({
    query: i,
    variables: c,
    context: {
      operationName: xe(i),
      widgetId: r,
      widgetType: t
    }
  });
}, cn = (r, t) => function(a, i) {
  return Qr(a, {
    ...i,
    context: {
      operationName: xe(a),
      ...i?.context,
      widgetId: r,
      widgetType: t
    }
  });
};
var Ce = { exports: {} }, se = {};
var ar;
function mt() {
  if (ar) return se;
  ar = 1;
  var r = lr, t = Symbol.for("react.element"), a = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, c = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, h = { key: !0, ref: !0, __self: !0, __source: !0 };
  function y(b, f, C) {
    var u, m = {}, x = null, R = null;
    C !== void 0 && (x = "" + C), f.key !== void 0 && (x = "" + f.key), f.ref !== void 0 && (R = f.ref);
    for (u in f) i.call(f, u) && !h.hasOwnProperty(u) && (m[u] = f[u]);
    if (b && b.defaultProps) for (u in f = b.defaultProps, f) m[u] === void 0 && (m[u] = f[u]);
    return { $$typeof: t, type: b, key: x, ref: R, props: m, _owner: c.current };
  }
  return se.Fragment = a, se.jsx = y, se.jsxs = y, se;
}
var ce = {};
var ir;
function yt() {
  return ir || (ir = 1, process.env.NODE_ENV !== "production" && (function() {
    var r = lr, t = Symbol.for("react.element"), a = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), h = Symbol.for("react.profiler"), y = Symbol.for("react.provider"), b = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), S = Symbol.iterator, A = "@@iterator";
    function D(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = S && e[S] || e[A];
      return typeof n == "function" ? n : null;
    }
    var d = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function O(e) {
      {
        for (var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), l = 1; l < n; l++)
          s[l - 1] = arguments[l];
        $("error", e, s);
      }
    }
    function $(e, n, s) {
      {
        var l = d.ReactDebugCurrentFrame, v = l.getStackAddendum();
        v !== "" && (n += "%s", s = s.concat([v]));
        var E = s.map(function(g) {
          return String(g);
        });
        E.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, E);
      }
    }
    var ue = !1, Re = !1, Le = !1, Oe = !1, te = !1, de;
    de = Symbol.for("react.module.reference");
    function _e(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === i || e === h || te || e === c || e === C || e === u || Oe || e === R || ue || Re || Le || typeof e == "object" && e !== null && (e.$$typeof === x || e.$$typeof === m || e.$$typeof === y || e.$$typeof === b || e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === de || e.getModuleId !== void 0));
    }
    function Te(e, n, s) {
      var l = e.displayName;
      if (l)
        return l;
      var v = n.displayName || n.name || "";
      return v !== "" ? s + "(" + v + ")" : s;
    }
    function fe(e) {
      return e.displayName || "Context";
    }
    function F(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && O("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case i:
          return "Fragment";
        case a:
          return "Portal";
        case h:
          return "Profiler";
        case c:
          return "StrictMode";
        case C:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case b:
            var n = e;
            return fe(n) + ".Consumer";
          case y:
            var s = e;
            return fe(s._context) + ".Provider";
          case f:
            return Te(e, e.render, "ForwardRef");
          case m:
            var l = e.displayName || null;
            return l !== null ? l : F(e.type) || "Memo";
          case x: {
            var v = e, E = v._payload, g = v._init;
            try {
              return F(g(E));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, L = 0, pe, he, ne, oe, z, ge, ae;
    function w() {
    }
    w.__reactDisabledLog = !0;
    function G() {
      {
        if (L === 0) {
          pe = console.log, he = console.info, ne = console.warn, oe = console.error, z = console.group, ge = console.groupCollapsed, ae = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: w,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        L++;
      }
    }
    function W() {
      {
        if (L--, L === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, e, {
              value: pe
            }),
            info: B({}, e, {
              value: he
            }),
            warn: B({}, e, {
              value: ne
            }),
            error: B({}, e, {
              value: oe
            }),
            group: B({}, e, {
              value: z
            }),
            groupCollapsed: B({}, e, {
              value: ge
            }),
            groupEnd: B({}, e, {
              value: ae
            })
          });
        }
        L < 0 && O("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var U = d.ReactCurrentDispatcher, V;
    function q(e, n, s) {
      {
        if (V === void 0)
          try {
            throw Error();
          } catch (v) {
            var l = v.stack.trim().match(/\n( *(at )?)/);
            V = l && l[1] || "";
          }
        return `
` + V + e;
      }
    }
    var we = !1, ve;
    {
      var Or = typeof WeakMap == "function" ? WeakMap : Map;
      ve = new Or();
    }
    function We(e, n) {
      if (!e || we)
        return "";
      {
        var s = ve.get(e);
        if (s !== void 0)
          return s;
      }
      var l;
      we = !0;
      var v = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var E;
      E = U.current, U.current = null, G();
      try {
        if (n) {
          var g = function() {
            throw Error();
          };
          if (Object.defineProperty(g.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(g, []);
            } catch (j) {
              l = j;
            }
            Reflect.construct(e, [], g);
          } else {
            try {
              g.call();
            } catch (j) {
              l = j;
            }
            e.call(g.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (j) {
            l = j;
          }
          e();
        }
      } catch (j) {
        if (j && l && typeof j.stack == "string") {
          for (var p = j.stack.split(`
`), I = l.stack.split(`
`), _ = p.length - 1, T = I.length - 1; _ >= 1 && T >= 0 && p[_] !== I[T]; )
            T--;
          for (; _ >= 1 && T >= 0; _--, T--)
            if (p[_] !== I[T]) {
              if (_ !== 1 || T !== 1)
                do
                  if (_--, T--, T < 0 || p[_] !== I[T]) {
                    var P = `
` + p[_].replace(" at new ", " at ");
                    return e.displayName && P.includes("<anonymous>") && (P = P.replace("<anonymous>", e.displayName)), typeof e == "function" && ve.set(e, P), P;
                  }
                while (_ >= 1 && T >= 0);
              break;
            }
        }
      } finally {
        we = !1, U.current = E, W(), Error.prepareStackTrace = v;
      }
      var Z = e ? e.displayName || e.name : "", H = Z ? q(Z) : "";
      return typeof e == "function" && ve.set(e, H), H;
    }
    function _r(e, n, s) {
      return We(e, !1);
    }
    function Tr(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function me(e, n, s) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return We(e, Tr(e));
      if (typeof e == "string")
        return q(e);
      switch (e) {
        case C:
          return q("Suspense");
        case u:
          return q("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            return _r(e.render);
          case m:
            return me(e.type, n, s);
          case x: {
            var l = e, v = l._payload, E = l._init;
            try {
              return me(E(v), n, s);
            } catch {
            }
          }
        }
      return "";
    }
    var ie = Object.prototype.hasOwnProperty, $e = {}, Be = d.ReactDebugCurrentFrame;
    function ye(e) {
      if (e) {
        var n = e._owner, s = me(e.type, e._source, n ? n.type : null);
        Be.setExtraStackFrame(s);
      } else
        Be.setExtraStackFrame(null);
    }
    function wr(e, n, s, l, v) {
      {
        var E = Function.call.bind(ie);
        for (var g in e)
          if (E(e, g)) {
            var p = void 0;
            try {
              if (typeof e[g] != "function") {
                var I = Error((l || "React class") + ": " + s + " type `" + g + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[g] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw I.name = "Invariant Violation", I;
              }
              p = e[g](n, g, l, s, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (_) {
              p = _;
            }
            p && !(p instanceof Error) && (ye(v), O("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", l || "React class", s, g, typeof p), ye(null)), p instanceof Error && !(p.message in $e) && ($e[p.message] = !0, ye(v), O("Failed %s type: %s", s, p.message), ye(null));
          }
      }
    }
    var Ar = Array.isArray;
    function Ae(e) {
      return Ar(e);
    }
    function Sr(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, s = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return s;
      }
    }
    function Nr(e) {
      try {
        return Ue(e), !1;
      } catch {
        return !0;
      }
    }
    function Ue(e) {
      return "" + e;
    }
    function Ge(e) {
      if (Nr(e))
        return O("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Sr(e)), Ue(e);
    }
    var Ve = d.ReactCurrentOwner, Dr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ye, He;
    function Ir(e) {
      if (ie.call(e, "ref")) {
        var n = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function jr(e) {
      if (ie.call(e, "key")) {
        var n = Object.getOwnPropertyDescriptor(e, "key").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Pr(e, n) {
      typeof e.ref == "string" && Ve.current;
    }
    function kr(e, n) {
      {
        var s = function() {
          Ye || (Ye = !0, O("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        s.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: s,
          configurable: !0
        });
      }
    }
    function Mr(e, n) {
      {
        var s = function() {
          He || (He = !0, O("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        s.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: s,
          configurable: !0
        });
      }
    }
    var Fr = function(e, n, s, l, v, E, g) {
      var p = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: e,
        key: n,
        ref: s,
        props: g,
        // Record the component responsible for creating this element.
        _owner: E
      };
      return p._store = {}, Object.defineProperty(p._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(p, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: l
      }), Object.defineProperty(p, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.freeze && (Object.freeze(p.props), Object.freeze(p)), p;
    };
    function Lr(e, n, s, l, v) {
      {
        var E, g = {}, p = null, I = null;
        s !== void 0 && (Ge(s), p = "" + s), jr(n) && (Ge(n.key), p = "" + n.key), Ir(n) && (I = n.ref, Pr(n, v));
        for (E in n)
          ie.call(n, E) && !Dr.hasOwnProperty(E) && (g[E] = n[E]);
        if (e && e.defaultProps) {
          var _ = e.defaultProps;
          for (E in _)
            g[E] === void 0 && (g[E] = _[E]);
        }
        if (p || I) {
          var T = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          p && kr(g, T), I && Mr(g, T);
        }
        return Fr(e, p, I, v, l, Ve.current, g);
      }
    }
    var Se = d.ReactCurrentOwner, Ke = d.ReactDebugCurrentFrame;
    function Q(e) {
      if (e) {
        var n = e._owner, s = me(e.type, e._source, n ? n.type : null);
        Ke.setExtraStackFrame(s);
      } else
        Ke.setExtraStackFrame(null);
    }
    var Ne;
    Ne = !1;
    function De(e) {
      return typeof e == "object" && e !== null && e.$$typeof === t;
    }
    function Je() {
      {
        if (Se.current) {
          var e = F(Se.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Wr(e) {
      return "";
    }
    var ze = {};
    function $r(e) {
      {
        var n = Je();
        if (!n) {
          var s = typeof e == "string" ? e : e.displayName || e.name;
          s && (n = `

Check the top-level render call using <` + s + ">.");
        }
        return n;
      }
    }
    function qe(e, n) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var s = $r(n);
        if (ze[s])
          return;
        ze[s] = !0;
        var l = "";
        e && e._owner && e._owner !== Se.current && (l = " It was passed a child from " + F(e._owner.type) + "."), Q(e), O('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, l), Q(null);
      }
    }
    function Qe(e, n) {
      {
        if (typeof e != "object")
          return;
        if (Ae(e))
          for (var s = 0; s < e.length; s++) {
            var l = e[s];
            De(l) && qe(l, n);
          }
        else if (De(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var v = D(e);
          if (typeof v == "function" && v !== e.entries)
            for (var E = v.call(e), g; !(g = E.next()).done; )
              De(g.value) && qe(g.value, n);
        }
      }
    }
    function Br(e) {
      {
        var n = e.type;
        if (n == null || typeof n == "string")
          return;
        var s;
        if (typeof n == "function")
          s = n.propTypes;
        else if (typeof n == "object" && (n.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        n.$$typeof === m))
          s = n.propTypes;
        else
          return;
        if (s) {
          var l = F(n);
          wr(s, e.props, "prop", l, e);
        } else if (n.PropTypes !== void 0 && !Ne) {
          Ne = !0;
          var v = F(n);
          O("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", v || "Unknown");
        }
        typeof n.getDefaultProps == "function" && !n.getDefaultProps.isReactClassApproved && O("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ur(e) {
      {
        for (var n = Object.keys(e.props), s = 0; s < n.length; s++) {
          var l = n[s];
          if (l !== "children" && l !== "key") {
            Q(e), O("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", l), Q(null);
            break;
          }
        }
        e.ref !== null && (Q(e), O("Invalid attribute `ref` supplied to `React.Fragment`."), Q(null));
      }
    }
    var Ze = {};
    function Xe(e, n, s, l, v, E) {
      {
        var g = _e(e);
        if (!g) {
          var p = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (p += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var I = Wr();
          I ? p += I : p += Je();
          var _;
          e === null ? _ = "null" : Ae(e) ? _ = "array" : e !== void 0 && e.$$typeof === t ? (_ = "<" + (F(e.type) || "Unknown") + " />", p = " Did you accidentally export a JSX literal instead of a component?") : _ = typeof e, O("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", _, p);
        }
        var T = Lr(e, n, s, v, E);
        if (T == null)
          return T;
        if (g) {
          var P = n.children;
          if (P !== void 0)
            if (l)
              if (Ae(P)) {
                for (var Z = 0; Z < P.length; Z++)
                  Qe(P[Z], e);
                Object.freeze && Object.freeze(P);
              } else
                O("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Qe(P, e);
        }
        if (ie.call(n, "key")) {
          var H = F(e), j = Object.keys(n).filter(function(Jr) {
            return Jr !== "key";
          }), Ie = j.length > 0 ? "{key: someKey, " + j.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ze[H + Ie]) {
            var Kr = j.length > 0 ? "{" + j.join(": ..., ") + ": ...}" : "{}";
            O(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ie, H, Kr, H), Ze[H + Ie] = !0;
          }
        }
        return e === i ? Ur(T) : Br(T), T;
      }
    }
    function Gr(e, n, s) {
      return Xe(e, n, s, !0);
    }
    function Vr(e, n, s) {
      return Xe(e, n, s, !1);
    }
    var Yr = Vr, Hr = Gr;
    ce.Fragment = i, ce.jsx = Yr, ce.jsxs = Hr;
  })()), ce;
}
var sr;
function Et() {
  return sr || (sr = 1, process.env.NODE_ENV === "production" ? Ce.exports = mt() : Ce.exports = yt()), Ce.exports;
}
var o = Et();
const ln = ({
  getValueByKey: r
}) => {
  const t = r("dixaApiTokenId")?.value, a = r("dixaApiTokenName")?.value;
  return /* @__PURE__ */ o.jsx(le, { children: /* @__PURE__ */ o.jsx(J, { label: "Dixa API-Token", children: !a || !t ? /* @__PURE__ */ o.jsx(o.Fragment, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ o.jsx(ke, { variant: "secondary", size: "small", children: a }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ o.jsx(ct, { to: `/settings/integrations/api-tokens/${t}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, bt = ({
  error: r
}) => r.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", un = ({
  errors: r
}) => r.some((t) => bt({ error: t })), Ct = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", dn = ({
  errors: r
}) => r.some((t) => Ct({ error: t })), xt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", fn = ({
  errors: r
}) => r.some((t) => xt({ error: t })), Rt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", pn = ({
  errors: r
}) => r.some((t) => Rt({ error: t })), Ot = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", hn = ({
  errors: r
}) => r.some((t) => Ot({ error: t })), _t = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", gn = ({
  errors: r
}) => r.some((t) => _t({ error: t })), Tt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", vn = ({
  errors: r
}) => r.some((t) => Tt({ error: t })), wt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", mn = ({
  errors: r
}) => r.some((t) => wt({ error: t })), At = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", yn = ({
  errors: r
}) => r.some((t) => At({ error: t })), St = ({
  error: r
}) => r.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", Nt = ({
  errors: r
}) => r.some((t) => St({ error: t })), Dt = (r) => {
  const { delay: t = 2e3 } = r || {}, [a, i] = N(!1);
  return M(() => {
    const h = a ? window.setTimeout(() => i(!1), t) : void 0;
    return () => window.clearTimeout(h);
  }, [t, a]), { isCopied: a, copy: (h) => {
    navigator.clipboard.writeText(h), i(!0);
  } };
}, It = "_errorWrapper_171rr_1", jt = "_copyIcon_171rr_5", Pe = {
  errorWrapper: It,
  copyIcon: jt
}, Pt = ({
  error: r,
  retry: t,
  isMisconfigured: a = !1
}) => {
  const c = r && Zr(r) && r?.graphQLErrors?.length > 0, { isCopied: h, copy: y } = Dt(), b = /* @__PURE__ */ o.jsx(
    Fe,
    {
      color: Y.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (a || c && Nt({
    errors: r.graphQLErrors
  }))
    return /* @__PURE__ */ o.jsxs(k, { margin: "0 0 100", padding: "200", className: Pe.errorWrapper, children: [
      /* @__PURE__ */ o.jsx(k, { margin: "0 300 0 0", alignItems: "center", children: b }),
      /* @__PURE__ */ o.jsx(ee.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!c)
    return /* @__PURE__ */ o.jsx(k, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ o.jsx(
      er.Item,
      {
        contentLeft: b,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const f = r?.graphQLErrors || [];
  return /* @__PURE__ */ o.jsxs(
    k,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: Pe.errorWrapper,
      children: [
        f.map((C, u) => {
          const m = C?.extensions?.integration, x = m?.message || r?.message || "No error message available", R = m?.responseBody && JSON.parse(m?.responseBody), S = R?.errorMessages || [], A = R?.warningMessages || [], D = [...S, ...A].join(" ");
          return /* @__PURE__ */ o.jsx(
            er.Item,
            {
              title: x,
              titleSecondary: D,
              contentLeft: b
            },
            u
          );
        }),
        /* @__PURE__ */ o.jsxs(k, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ o.jsx(
            et,
            {
              variant: "info",
              description: /* @__PURE__ */ o.jsx(ee.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ o.jsxs(k, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            t && /* @__PURE__ */ o.jsx(re, { variant: "secondary", icon: "sync", onClick: () => t(), children: "Retry" }),
            /* @__PURE__ */ o.jsx(
              re,
              {
                variant: "secondary",
                icon: h ? "done" : "copy",
                onClick: () => y(JSON.stringify(f, null, 2)),
                className: Pe.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
}, kt = ({
  headline: r,
  text: t,
  children: a,
  onConfirm: i,
  onCancel: c,
  confirmLabel: h,
  cancelLabel: y = "Cancel",
  confirmVariant: b = "primary",
  cancelVariant: f = "secondary",
  isOpen: C,
  setIsOpen: u,
  showOnClose: m = !1
}) => /* @__PURE__ */ o.jsxs(
  rt,
  {
    isOpen: C,
    onClose: () => {
      c && c(), u(!1);
    },
    children: [
      /* @__PURE__ */ o.jsx(
        tt,
        {
          title: r,
          onClose: m ? c : void 0
        }
      ),
      /* @__PURE__ */ o.jsxs(nt, { children: [
        t && /* @__PURE__ */ o.jsx("div", { style: { width: "600px" }, children: t }),
        a
      ] }),
      /* @__PURE__ */ o.jsx(
        ot,
        {
          confirmOnClick: i ? () => {
            i(), u(!1);
          } : void 0,
          cancelOnClick: () => {
            c && c(), u(!1);
          },
          confirmName: h,
          cancelName: y,
          confirmProps: { variant: b },
          cancelProps: { variant: f }
        }
      )
    ]
  }
);
function En(r, t = !0) {
  try {
    return JSON.parse(JSON.stringify(r));
  } catch {
    return t && console.error(`Could not make a copy of ${JSON.stringify(r)}`), {};
  }
}
const bn = (r) => `${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()}`, br = "DD MMM YYYY @ HH:mm";
function Cn(r) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      r.toUpperCase()
    ) ?? r;
  } catch {
    return r;
  }
}
const xn = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Rn = (r) => {
  if (!r?.trim())
    return "Please add a valid subdomain";
  const a = ["https://", "http://"].find(
    (h) => r.startsWith(h)
  ), i = a ? `Please remove the protocol \`${a}\` from the hostname` : "", c = r.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (i && c)
    return `Please remove the protocol \`${a}\` and the trailing \`/\` from the hostname`;
  if (i)
    return i;
  if (c)
    return c;
};
function Mt(r) {
  const t = r.split(".")[1];
  if (!t)
    throw Error("Invalid token");
  const a = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(a).toString());
  } catch (i) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${i}`
    );
  }
}
function Ft(r) {
  const { user_id: t, iss: a } = Mt(r);
  return {
    "x-integration-user-id": t,
    "x-integration-organization-id": a
  };
}
function Lt(r) {
  return r.startsWith("http://localhost");
}
const Wt = ur(null);
function $t() {
  const r = dr(Wt);
  if (r === null)
    throw Error(
      "useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider"
    );
  return r;
}
function On() {
  return {
    isInboundOAuth: !1,
    setIsInboundOAuth: () => {
    },
    hasTriggeredAuthorization: !1,
    setHasTriggeredAuthorization: () => {
    }
  };
}
function Cr() {
  return { track: (t, a) => window._partner.events.emit(t, a) };
}
const Bt = (r) => {
  switch (r) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: Y.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: Y.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: Y.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: Y.red[200],
        tooltip: "Connection timeout"
      };
    case "NOT_CONNECTED":
    default:
      return {
        icon: "exclamation-circle-filled",
        color: Y.neutral[500],
        tooltip: "Not connected"
      };
  }
}, _n = ({
  configuration: r,
  integrationId: t,
  integrationType: a,
  label: i
}) => {
  const [c, h] = N("CONNECTING"), [y, b] = N(""), [f, C] = N(null), { track: u } = Cr(), { icon: m, color: x, tooltip: R } = Bt(c), S = 3, A = 15, D = 2e3, [d, O] = N({}), [$, ue] = N(0), [Re, Le] = N(D), [Oe, te] = N(!1), [de, _e] = N(S), {
    isInboundOAuth: Te,
    setIsInboundOAuth: fe,
    hasTriggeredAuthorization: F,
    setHasTriggeredAuthorization: B
  } = $t(), { baseUrl: L } = r, pe = `${L}/auth/connect/${a.toLowerCase()}/${t}`, he = `${L}/auth/status/${a.toLowerCase()}/${t}`, ne = c === "CONNECTING", oe = (w) => Object.keys(w).length === 0, z = () => {
    te(!1), ue(0);
  };
  M(() => {
    const w = localStorage.getItem("authData");
    if (w) {
      const W = JSON.parse(w ?? "{}").access_token;
      O({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${W}`,
          ...Lt(L) && Ft(W)
        }
      });
    }
  }, [L]), M(() => {
    oe(d) || te(!0);
  }, [d]);
  const ge = () => {
    _e(A), fetch(he, { ...d }).then((w) => w.json()).then(({ data: w }) => {
      const { status: G, createdAt: W, createdByName: U } = w;
      if (G === "CONNECTING" && h("CONNECTING"), G === "CONNECTED") {
        if (u("settings:view:oauth:succeeded", {
          widgetId: t,
          widgetType: a
        }), h("CONNECTED"), W && U) {
          const V = new Date(W);
          isNaN(V.getTime()) || C(V), b(U);
        }
        z();
      }
      G === "NOT_CONNECTED" && (h("NOT_CONNECTED"), z());
    }).catch((w) => {
      console.warn(
        `Fetching OAuth status failed for ${a} ${t}`,
        w
      ), h("CONNECTION_FAILED");
    });
  };
  lt(
    () => {
      $ >= de ? (h("CONNECTION_TIMEOUT"), z()) : (ge(), ue($ + 1));
    },
    Oe ? Re : null
  );
  const ae = () => {
    u("settings:view:oauth:started", {
      widgetId: t,
      widgetType: a
    }), fetch(pe, { ...d }).then((w) => w.json()).then(({ data: w }) => {
      const { url: G } = w, W = 620, U = 800, V = window.innerWidth / 2 - W / 2, q = window.innerHeight / 2 - U / 2;
      h("CONNECTING"), te(!0), window.open(
        G,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${W},
						height=${U},
						left=${V},
						top=${q}`
      );
    }).catch((w) => {
      console.warn(
        `Fetching OAuth connection failed for ${a} ${t}`,
        w
      ), h("CONNECTION_FAILED");
    });
  };
  return M(() => {
    Te && !F && !oe(d) && (B(!0), fe(!1), ae());
  }, [d]), /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(le, { span: 3, children: /* @__PURE__ */ o.jsx(
      J,
      {
        label: i,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ o.jsxs(k, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ o.jsx(
            re,
            {
              icon: "key",
              variant: "secondary",
              onClick: ae,
              disabled: ne,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ o.jsx(fr, { content: R, children: ne ? /* @__PURE__ */ o.jsx(pr, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ o.jsxs(k, { alignItems: "center", gap: "200", children: [
            /* @__PURE__ */ o.jsx(
              Fe,
              {
                "data-testid": "oauth-button-status-icon",
                name: m,
                color: x
              }
            ),
            c === "CONNECTED" && y && f && /* @__PURE__ */ o.jsxs(ee.Paragraph, { variant: "4", subdued: !0, children: [
              "Authorized by ",
              y,
              " at",
              " ",
              hr(f).format(br)
            ] })
          ] }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ o.jsx(le, { span: 3 })
  ] });
}, xr = ur(null), Tn = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  xr.Provider
);
function Rr() {
  const r = dr(xr);
  if (r === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return r;
}
const Ut = "_settingsWrapper_eleyu_1", Gt = {
  settingsWrapper: Ut
}, Vt = Me`
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_get_lists_response {
          ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
            data {
              type
              id
              attributes {
                name
                created
                updated
              }
              links {
                self
              }
            }
            links {
              self
            }
          }
          ... on Klaviyo_ClientError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
          ... on Klaviyo_ServerError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
        }
      }
    }
  }
`, cr = [], wn = ({
  settings: r,
  getValueByKey: t,
  handleChangeSelect: a
}) => {
  const i = "subscriptionListId", h = r?.find(
    (d) => d.key === i
  )?.label ?? "Activate re-/subscription list selection", y = t(i)?.value, { useQuery: b } = Rr(), [f, C] = N(cr), [u, m] = N(!!y), [x, R] = N(y), {
    data: S,
    error: A,
    loading: D
  } = b(Vt, {
    skip: !u,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return M(() => {
    y && (R(y), m(!0));
  }, [y]), M(() => {
    const d = S?.Klaviyo?.get_lists;
    if (u && d && !D && !A) {
      const O = d?.data?.map(
        ($) => ({
          value: $?.id,
          label: $?.attributes?.name
        })
      ) || cr;
      C(O);
    }
  }, [u, S, D, A]), /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(le, { span: 3, children: /* @__PURE__ */ o.jsxs(
      k,
      {
        gap: "300",
        flexDirection: "column",
        className: Gt.settingsWrapper,
        children: [
          /* @__PURE__ */ o.jsx(J, { label: h, children: /* @__PURE__ */ o.jsx(
            at,
            {
              input: {
                name: `${i}-switch`,
                value: "switchValueFromComponent",
                checked: u,
                onChange: () => {
                  const d = !u;
                  d || a(i, {
                    selectedValues: [
                      {
                        label: "",
                        value: ""
                      }
                    ]
                  }), m(d);
                }
              }
            }
          ) }),
          u && A && !D && /* @__PURE__ */ o.jsx(J, { children: /* @__PURE__ */ o.jsx(Pt, { error: A }) }),
          u && !A && D && /* @__PURE__ */ o.jsx(J, { children: /* @__PURE__ */ o.jsx(k, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ o.jsx(pr, {}) }) }),
          u && !A && !D && f && /* @__PURE__ */ o.jsx(J, { label: "Available lists to subscribe to", children: /* @__PURE__ */ o.jsx(
            it,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (d) => {
                a(i, d), R(d?.selectedValues?.[0].value);
              },
              getItemTitleByValue: (d) => d ? /* @__PURE__ */ o.jsx(ee.Paragraph, { children: d.label }) : null,
              value: x ? [
                {
                  label: (f || []).find(
                    (d) => d.value === x
                  )?.label,
                  value: x
                }
              ] : [],
              equalityFn: (d, O) => d.value === O.value,
              children: f.map((d) => /* @__PURE__ */ o.jsx(st.Item, { value: d, children: d.label }, d.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ o.jsx(le, { span: 3 })
  ] });
}, An = (r) => {
  if (r == null)
    return null;
  if (typeof r == "boolean" || r === "true" || r === "false") {
    const i = r === "true" || r === !0;
    return /* @__PURE__ */ o.jsx(
      Fe,
      {
        name: i ? "check-circle-filled" : "close-circle-filled",
        color: i ? Y.green[500] : Y.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${i ? "true" : "false"}`
      }
    );
  }
  if (typeof r == "number" || /^\d*\.?\d+$/.test(r))
    return /* @__PURE__ */ o.jsx(ke, { variant: "success", size: "small", children: r });
  if (r.startsWith("days_ago: ")) {
    const i = r.replace("days_ago: ", ""), c = i.startsWith("-"), h = i === "0", y = c ? `${i.replace("-", "")} days ago` : `in ${i} days`;
    return /* @__PURE__ */ o.jsx(ee.Paragraph, { variant: "5", color: "secondary", children: h ? "today" : y });
  }
  const a = hr(r);
  return a.isValid() ? /* @__PURE__ */ o.jsx(ee.Paragraph, { variant: "5", color: "secondary", children: a.format(br) }) : /* @__PURE__ */ o.jsx(ke, { variant: "info", size: "small", children: r });
}, Sn = (r) => {
  const {
    isCreationMode: t = !1,
    componentProps: a,
    name: i,
    control: c,
    rules: h,
    defaultValue: y,
    shouldUnregister: b,
    label: f,
    helpIcon: C
  } = r, [u, m] = N(t), { field: x } = dt({
    name: i,
    control: c,
    rules: h,
    defaultValue: y,
    shouldUnregister: b
  }), R = typeof f == "string" ? f : "";
  if (!u)
    return /* @__PURE__ */ o.jsx(J, { label: f, helpIcon: C, children: /* @__PURE__ */ o.jsxs(
      re,
      {
        "data-testid": `secret-field-button-${i}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => m(!0),
        children: [
          "Update ",
          R
        ]
      }
    ) });
  const A = {
    ...a,
    prefix: t ? a?.prefix : {
      type: "button",
      button: { icon: "close", onClick: () => {
        x.onChange(""), m(!1);
      } }
    }
  };
  return /* @__PURE__ */ o.jsx(ut, { ...r, componentProps: A });
}, Yt = {
  submit: "Submit",
  delete: "Delete",
  confirmDelete: "Yes",
  cancelDelete: "No"
}, Nn = ({
  integrationType: r,
  integrationId: t,
  widgetName: a,
  isCreationMode: i,
  isSubmitting: c,
  automationCouplingState: h,
  onConfirmDelete: y,
  labels: b,
  deleteConfirmationBody: f,
  confirmDeleteVariant: C = "primary"
}) => {
  const { track: u } = Cr(), [m, x] = N(!1), R = { ...Yt, ...b }, S = !h || !h.isCoupled, A = () => {
    t && u("settings:view:delete:requested", {
      widgetId: t,
      widgetType: r
    }), x(!0);
  }, D = () => {
    t && u("settings:view:delete:canceled", {
      widgetId: t,
      widgetType: r
    });
  };
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsxs(k, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ o.jsx(re, { type: "submit", isLoading: c, disabled: c, children: R.submit }),
      !i && /* @__PURE__ */ o.jsx(
        fr,
        {
          content: "The widget is used in automations",
          disabled: S,
          children: /* @__PURE__ */ o.jsx(
            re,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              type: "button",
              onClick: A,
              disabled: !S,
              isLoading: h?.isLoading,
              children: R.delete
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ o.jsx(
      kt,
      {
        isOpen: m,
        setIsOpen: x,
        confirmVariant: C,
        confirmLabel: R.confirmDelete,
        cancelLabel: R.cancelDelete,
        onCancel: D,
        onConfirm: y,
        children: /* @__PURE__ */ o.jsx(k, { children: f ?? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
          "Are you sure you want to delete the ",
          r,
          ' integration "',
          a,
          '"?'
        ] }) })
      }
    )
  ] });
}, Ht = Me`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Kt = Me`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function Dn(r) {
  const { useQuery: t, useMutation: a } = Rr(), [i, c] = N(), [h, y] = N(), [b, f] = N(!1), {
    loading: C,
    data: u,
    error: m
  } = t(
    Ht,
    {
      skip: !r,
      variables: {
        conversationId: r?.toString()
      }
    }
  ), [x, { loading: R, error: S }] = a(
    Kt
  ), A = async (D, d) => await x({
    variables: {
      conversationId: (d ?? r)?.toString(),
      data: D
    }
  }).then(
    ({ data: $ }) => c($?.Storage?.storeWidgetData?.data ?? {})
  );
  return M(() => {
    !C && u && c(u?.Storage?.widgetData ?? {});
  }, [u, C]), M(() => m && y(m), [m]), M(() => f(C), [C]), M(() => S && y(S), [S]), M(() => f(R), [R]), {
    data: i,
    loading: b,
    store: A,
    error: h
  };
}
export {
  Pt as DisplayErrors,
  ln as DixaApiTokenSettings,
  Wt as InboundOAuthContext,
  kt as IntegrationModal,
  wn as KlaviyoSubscribeSetting,
  _n as OAuthSettings,
  Sn as PartnerHookFormSecretText,
  Tn as WidgetContextProvider,
  Nn as WidgetSettingsFormFooter,
  bn as capitalizeFirstCharacter,
  xn as countryCodes,
  On as createMockInboundOAuthContextOptions,
  En as deepClone,
  br as defaultDateFormat,
  An as displayAttributeValue,
  Bt as getConnectionStatusValues,
  Cn as getCountryNameFromCountryCode,
  Vt as getListsQuery,
  Ft as getPartnerDevApiHeaders,
  un as hasDixaHeaderCheckError,
  dn as hasDownstreamApiAuthorizationError,
  vn as hasDownstreamApiBadRequestError,
  gn as hasDownstreamApiConflictError,
  mn as hasDownstreamApiForbiddenError,
  hn as hasDownstreamApiNotFoundError,
  fn as hasDownstreamApiPermissionError,
  pn as hasDownstreamApiServiceUnavailableError,
  yn as hasDownstreamApiTooManyRequestsError,
  Nt as hasWidgetMisconfiguredError,
  bt as isDixaHeaderCheckError,
  Ct as isDownstreamApiAuthorizationError,
  Tt as isDownstreamApiBadRequestError,
  _t as isDownstreamApiConflictError,
  wt as isDownstreamApiForbiddenError,
  Ot as isDownstreamApiNotFoundError,
  xt as isDownstreamApiPermissionError,
  Rt as isDownstreamApiServiceUnavailableError,
  At as isDownstreamApiTooManyRequestsError,
  Lt as isRunningLocalPartnerApi,
  St as isWidgetMisconfiguredError,
  sn as makeExecuteQuery,
  an as makeUseLazyQuery,
  cn as makeUseMutation,
  on as makeUseQuery,
  Mt as parseAccessToken,
  Dt as useCopyWithDelay,
  Dn as useData,
  $t as useInboundOAuthContext,
  Cr as useTracking,
  Rr as useWidgetContext,
  Rn as validateApiHostName
};
